

//set cookie value
function setCookie(cname, cvalue) {
  document.cookie = cname + "=" + cvalue + ";99999999999;path=/";
}

//get cookie value
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return false;
}

//update unit dropdown on front side
function estimateDistanceUnitUpdate() {
  if (window.measurement == unitMile) {
    document.querySelector('select[name="unitsEst"]').selectedIndex = 0;
  } else {
    document.querySelector('select[name="unitsEst"]').selectedIndex = 1;
  }
}

//chnage Miles to KM for chart
function milesToKmChartUnits() {
  var factor, unit, lenght, decimal;
  if (window.measurement == "km") {
    factor = 1.6;
    unit = "km";
    decimal = 1;
  } else {
    factor = 1;
    unit = "M";
    decimal = 0;
  }

  document.querySelectorAll(".M1").forEach((item) => {
    lenght = 1 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M2").forEach((item) => {
    lenght = 2 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M3").forEach((item) => {
    lenght = 3 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M4").forEach((item) => {
    lenght = 4 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M5").forEach((item) => {
    lenght = 5 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M6").forEach((item) => {
    lenght = 6 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M7").forEach((item) => {
    lenght = 7 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M8").forEach((item) => {
    lenght = 8 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M9").forEach((item) => {
    lenght = 9 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M10").forEach((item) => {
    lenght = 10 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M11").forEach((item) => {
    lenght = 11 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M12").forEach((item) => {
    lenght = 12 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M13").forEach((item) => {
    lenght = 13 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });

  document.querySelectorAll(".M14").forEach((item) => {
    lenght = 14 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M15").forEach((item) => {
    lenght = 15 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M16").forEach((item) => {
    lenght = 16 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M17").forEach((item) => {
    lenght = 17 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M18").forEach((item) => {
    lenght = 18 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M19").forEach((item) => {
    lenght = 19 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M20").forEach((item) => {
    lenght = 20 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M21").forEach((item) => {
    lenght = 21 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M22").forEach((item) => {
    lenght = 22 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M23").forEach((item) => {
    lenght = 23 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M24").forEach((item) => {
    lenght = 24 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M25").forEach((item) => {
    lenght = 25 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M26").forEach((item) => {
    lenght = 26 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M27").forEach((item) => {
    lenght = 27 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M28").forEach((item) => {
    lenght = 28 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M29").forEach((item) => {
    lenght = 29 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
  document.querySelectorAll(".M30").forEach((item) => {
    lenght = 30 * factor;
    item.innerHTML = lenght.toFixed(decimal) + unit;
  });
}

//update the mearsurement veriable
function unitEst(defaultUnit) {
  var toggleButtonUnit;
  if (defaultUnit) {
    measurement = planEstDisUnit;
  } else {
    if (document.querySelector('select[name="unitsEst"]').selectedIndex == 0) {
      measurement = unitMile;
      toggleButtonUnit = unitKm;
    } else {
      measurement = unitKm;
      toggleButtonUnit = unitMile;
    }
  }

  setCookie(paceCookie, measurement);
}

//update table unit to show
function tableUnit() {
  document.getElementById("currentUnit").innerHTML = "m:s  /  " + window.measurement;

  if (window.measurement == unitMile) {
    toggleButtonUnit = "KM";
  } else {
    toggleButtonUnit = "MILES";
  }

  document.getElementById("toggle-measurement").innerHTML =
    "CHANGE TRAINING PLAN TO " + toggleButtonUnit;
}

//to show the timing for distance estimated.
function showDistanceForPrictedTime() {
  var lengthEstt = document.forms.input2.lengthEst.value,
    unitEstt;
  var selection = document.querySelector('select[name="unitsEst"]');

  if (selection.selectedIndex == 0) {
    unitEstt = "miles";
  } else {
    unitEstt = "km";
  }

  if (lengthEstt <= 0 || isNaN(lengthEstt)) {
    return;
  } else {
    document.getElementById("distanceEstimated").innerText =
      lengthEstt + " " + unitEstt;
  }
}

//default values for chart
function planDefaultValues() {
  var form = document.forms.input2;

  // race time in min, lengths in m.

  form.hours.value = planHours;
  form.minutes.value = planMins;
  form.seconds.value = planSec;
  form.lengthDone.value = planDistance;
  form.lengthEst.value = planEstDis;

  if (planDistanceUnit.includes(unitMile)) {
    document.querySelector('select[name="unitsDone"]').selectedIndex = 0;
  } else {
    document.querySelector('select[name="unitsDone"]').selectedIndex = 1;
  }

  if (planEstDisUnit.includes(unitMile)) {
    document.querySelector('select[name="unitsEst"]').selectedIndex = 0;
  } else {
    document.querySelector('select[name="unitsEst"]').selectedIndex = 1;
  }

  // measurement = planEstDisUnit;
}

function estTime() {
  var frm = document.forms.input2;
  // race time in min, lengths in m.
  var timeDone =
    frm.hours.value * 60 + frm.minutes.value * 1 + frm.seconds.value / 60;
  var lengthDone = frm.lengthDone.value;
  var lengthDoneFixed = frm.lengthDone.value;
  var lengthEst = frm.lengthEst.value;

  if (timeDone <= 0 || isNaN(timeDone)) {
    alert("Please enter a time");
    return false;
  }

  if (lengthDone <= 0 || isNaN(lengthDone)) {
    alert("Please enter a distance.");
    return false;
  }

  if (lengthDoneFixed <= 0 || isNaN(lengthDoneFixed)) {
    alert("Please enter a distance.");
    return false;
  }

  if (lengthEst <= 0 || isNaN(lengthEst)) {
    alert("Please enter distance to estimate your time for.");
    return false;
  }

  document.getElementById("distanceEstimatedLabel").style.display = "block";
  document.getElementById("toggle-measurement").style.display = "block";

  //view tootle button and fixed distance of estimated

  // let a = document.querySelectorAll("[id=whiteInput]");
  // a.forEach((item) => {
  //   item.setAttribute("disabled", "disabled");
  // });

  if (frm.unitsEst.options[0].selected) {
    lengthEst *= 1609;
  } else {
    lengthEst *= 1000;
  }

  if (frm.unitsDone.options[0].selected) {
    lengthDoneFixed *= 1609;
    lengthDone *= 1609;
  } else {
    lengthDoneFixed *= 1000;
    lengthDone *= 1000;
  }

  //Time = Distance / Speed
  //calculate estimated time in minutes
  var timeEst, hourEst, minuteEst, secondEst, speed;
  speed = lengthDoneFixed / timeDone;
  timeEst = timeDone * Math.pow(lengthEst / lengthDoneFixed, 1.06);

  hourEst = Math.floor(timeEst / 60);
  timeEst -= hourEst * 60;
  minuteEst = Math.floor(timeEst);
  timeEst -= minuteEst;
  secondEst = Math.floor(timeEst * 60);
  if (hourEst < 10) {
    frm.hourEst.value = "0" + hourEst;
  } else {
    frm.hourEst.value = hourEst;
  }

  if (minuteEst < 10) {
    frm.minuteEst.value = "0" + minuteEst;
  } else {
    frm.minuteEst.value = minuteEst;
  }
  if (secondEst < 10) {
    frm.secondEst.value = "0" + secondEst;
  } else {
    frm.secondEst.value = secondEst;
  }

  //calculate easy pace

  var easyTime,
    easyPace,
    easyPaceMinEst,
    easyPaceSecEst,
    easyTimeA,
    easyTImeB,
    easyDistance;
  easyTime = timeDone * Math.pow(44312 / lengthDone, 1.06);
  easyTimeA = easyTime;
  easyTimeB = easyTime;

  if (window.measurement == unitKm) {
    // easyDistance = 44.312;
    easyDistance = 39.42893;
  } else {
    // easyDistance = 27.5342;
    easyDistance = 24.5;
  }

  easyPace = easyTime / easyDistance;

  // if (frm.unitsDone.options[0].selected) {
  //   easyPace = easyPace / 2.65;
  // }
  easyPaceMinEst = Math.floor(easyPace);
  easyPace -= easyPaceMinEst;
  easyPaceSecEst = Math.floor(easyPace * 60);

  if (easyPaceSecEst < 10) {
    frm.easyPaceMinimMin.value =
      (easyPaceMinEst < 10 ? "0" + easyPaceMinEst : easyPaceMinEst) +
      ":" +
      "0" +
      easyPaceSecEst;
  } else {
    frm.easyPaceMinimMin.value =
      (easyPaceMinEst < 10 ? "0" + easyPaceMinEst : easyPaceMinEst) +
      ":" +
      easyPaceSecEst;
  }

  document.querySelectorAll(".easyPace").forEach((item) => {
    item.innerHTML =
      " - " +
      easyPaceMinEst.toString().padStart(2, "0") +
      ":" +
      easyPaceSecEst.toString().padStart(2, "0") +
      " mins/" +
      window.measurement;
  });

  //calculate marathon pace
  var marTime,
    marPace,
    marPaceMinEst,
    marPaceSecEst,
    marTimeA,
    marTImeB,
    marDistance;
  marTime = timeDone * Math.pow(42195 / lengthDone, 1.06);
  marTimeA = marTime;
  marTimeB = marTime;

  if (window.measurement == unitKm) {
    marDistance = 42.195;
  } else {
    marDistance = 26.2;
  }

  marPace = marTime / marDistance;

  marPaceMinEst = Math.floor(marPace);
  marPace -= marPaceMinEst;
  marPaceSecEst = Math.floor(marPace * 60);

  if (marPaceSecEst < 10) {
    frm.halfMarPaceMinEst.value =
      (marPaceMinEst < 10 ? "0" + marPaceMinEst : marPaceMinEst) +
      ":" +
      "0" +
      marPaceSecEst;
  } else {
    frm.halfMarPaceMinEst.value =
      (marPaceMinEst < 10 ? "0" + marPaceMinEst : marPaceMinEst) +
      ":" +
      marPaceSecEst;
  }

  document.querySelectorAll(".steadyPace").forEach((item) => {
    item.innerHTML =
      " - " +
      marPaceMinEst.toString().padStart(2, "0") +
      ":" +
      marPaceSecEst.toString().padStart(2, "0") +
      " mins/" +
      window.measurement;
  });

  //calculate half marathon pace (steady)
  var halfMarTime,
    halfMarPace,
    halfMarPaceMinEst,
    halfMarPaceSecEst,
    halfMarDistance;
  halfMarTime = timeDone * Math.pow(21097 / lengthDone, 1.06);

  if (window.measurement == unitKm) {
    halfMarDistance = 21.0975;
  } else {
    halfMarDistance = 13.1;
  }
  halfMarPace = halfMarTime / halfMarDistance;

  // if (frm.unitsDone.options[0].selected) {
  //   halfMarPace = halfMarPace / 2.65;
  // }

  halfMarPaceMinEst = Math.floor(halfMarPace);
  halfMarPace -= halfMarPaceMinEst;
  halfMarPaceSecEst = Math.floor(halfMarPace * 60);
  if (halfMarPaceSecEst < 10) {
    frm.tempoPaceMinEst.value =
      (halfMarPaceMinEst < 10 ? "0" + halfMarPaceMinEst : halfMarPaceMinEst) +
      ":" +
      "0" +
      halfMarPaceSecEst;
  } else {
    frm.tempoPaceMinEst.value =
      (halfMarPaceMinEst < 10 ? "0" + halfMarPaceMinEst : halfMarPaceMinEst) +
      ":" +
      halfMarPaceSecEst;
  }

  document.querySelectorAll(".tempoPace").forEach((item) => {
    item.innerHTML =
      " - " +
      halfMarPaceMinEst.toString().padStart(2, "0") +
      ":" +
      halfMarPaceSecEst.toString().padStart(2, "0") +
      " mins/" +
      window.measurement;
  });

  //calculate 10k  pace
  var tenKTime, tenKPace, tenKPaceMinEst, tenKPaceSecEst, tenKDistance;
  tenKTime = timeDone * Math.pow(10000 / lengthDone, 1.06);

  if (window.measurement == unitKm) {
    tenKDistance = 10;
  } else {
    tenKDistance = 6.213;
  }

  tenKPace = tenKTime / tenKDistance;

  // if (frm.unitsDone.options[0].selected) {
  //   tenKPace = tenKPace / 2.65;
  // }

  tenKPaceMinEst = Math.floor(tenKPace);
  tenKPace -= tenKPaceMinEst;
  tenKPaceSecEst = Math.floor(tenKPace * 60);
  frm.tenKPaceMinEst.value = tenKPaceMinEst;

  if (tenKPaceSecEst < 10) {
    frm.tenKPaceMinEst.value =
      (tenKPaceMinEst < 10 ? "0" + tenKPaceMinEst : tenKPaceMinEst) +
      ":" +
      "0" +
      tenKPaceSecEst;
  } else {
    frm.tenKPaceMinEst.value =
      (tenKPaceMinEst < 10 ? "0" + tenKPaceMinEst : tenKPaceMinEst) +
      ":" +
      tenKPaceSecEst;
  }

  document.querySelectorAll(".tenkPace").forEach((item) => {
    item.innerHTML =
      " - " +
      tenKPaceMinEst.toString().padStart(2, "0") +
      ":" +
      tenKPaceSecEst.toString().padStart(2, "0") +
      " mins/" +
      window.measurement;
  });

  //calculate 5k  pace

  var fiveKTime, fiveKPace, fiveKPaceMinEst, fiveKPaceSecEst, fiveKDistance;
  fiveKTime = timeDone * Math.pow(5000 / lengthDone, 1.06);

  if (window.measurement == unitKm) {
    fiveKDistance = 5;
  } else {
    fiveKDistance = 3.10686;
  }

  fiveKPace = fiveKTime / fiveKDistance;

  // if (frm.unitsDone.options[0].selected) {
  //   fiveKPace = fiveKPace / 2.6;
  // }

  fiveKPaceMinEst = Math.floor(fiveKPace);
  fiveKPace -= fiveKPaceMinEst;
  fiveKPaceSecEst = Math.floor(fiveKPace * 60);
  frm.fiveKPaceMinEst.value = fiveKPaceMinEst;

  if (fiveKPaceSecEst < 10) {
    frm.fiveKPaceMinEst.value =
      (fiveKPaceMinEst < 10 ? "0" + fiveKPaceMinEst : fiveKPaceMinEst) +
      ":" +
      "0" +
      fiveKPaceSecEst;
  } else {
    frm.fiveKPaceMinEst.value =
      (fiveKPaceMinEst < 10 ? "0" + fiveKPaceMinEst : fiveKPaceMinEst) +
      ":" +
      fiveKPaceSecEst;
  }

  document.querySelectorAll(".fivekPace").forEach((item) => {
    item.innerHTML =
      " - " +
      fiveKPaceMinEst.toString().padStart(2, "0") +
      ":" +
      fiveKPaceSecEst.toString().padStart(2, "0") +
      " mins/" +
      window.measurement;
  });

  //calculate 3k  pace
  var threeKTime,
    threeKPace,
    threeKPaceMinEst,
    threeKPaceSecEst,
    threeKDistance;
  threeKTime = timeDone * Math.pow(3000 / lengthDone, 1.06);

  if (window.measurement == unitKm) {
    threeKDistance = 3;
  } else {
    threeKDistance = 1.86411;
  }

  threeKPace = threeKTime / threeKDistance;
  // if (frm.unitsDone.options[0].selected) {
  //   threeKPace = threeKPace / 2.6;
  // }
  threeKPaceMinEst = Math.floor(threeKPace);
  threeKPace -= threeKPaceMinEst;
  threeKPaceSecEst = Math.floor(threeKPace * 60);
  frm.threeKPaceMinEst.value = threeKPaceMinEst;

  if (threeKPaceSecEst < 10) {
    frm.threeKPaceMinEst.value =
      (threeKPaceMinEst < 10 ? "0" + threeKPaceMinEst : threeKPaceMinEst) +
      ":" +
      "0" +
      threeKPaceSecEst;
  } else {
    frm.threeKPaceMinEst.value =
      (threeKPaceMinEst < 10 ? "0" + threeKPaceMinEst : threeKPaceMinEst) +
      ":" +
      threeKPaceSecEst;
  }

  document.querySelectorAll(".threekPace").forEach((item) => {
    item.innerHTML =
      " - " +
      threeKPaceMinEst.toString().padStart(2, "0") +
      ":" +
      threeKPaceSecEst.toString().padStart(2, "0") +
      " mins/" +
      window.measurement;
  });

  //calculate 1M  pace
  var oneMTime, oneMPace, oneMPaceMinEst, oneMPaceSecEst, oneMDistance;
  oneMTime = timeDone * Math.pow(1600 / lengthDone, 1.06);

  if (window.measurement == unitKm) {
    oneMDistance = 1.6;
  } else {
    oneMDistance = 1;
  }

  oneMPace = oneMTime / oneMDistance;
  // if (frm.unitsDone.options[0].selected) {
  //   oneMPace = oneMPace / 2.6;
  // }
  oneMPaceMinEst = Math.floor(oneMPace);
  oneMPace -= oneMPaceMinEst;
  oneMPaceSecEst = Math.floor(oneMPace * 60);
  frm.oneMPaceMinEst.value = oneMPaceMinEst;

  if (oneMPaceSecEst < 10) {
    frm.oneMPaceMinEst.value =
      (oneMPaceMinEst < 10 ? "0" + oneMPaceMinEst : oneMPaceMinEst) +
      ":" +
      "0" +
      oneMPaceSecEst;
  } else {
    frm.oneMPaceMinEst.value =
      (oneMPaceMinEst < 10 ? "0" + oneMPaceMinEst : oneMPaceMinEst) +
      ":" +
      oneMPaceSecEst;
  }

  document.querySelectorAll(".onemilePace").forEach((item) => {
    item.innerHTML =
      " - " +
      oneMPaceMinEst.toString().padStart(2, "0") +
      ":" +
      oneMPaceSecEst.toString().padStart(2, "0") +
      " mins/" +
      window.measurement;
  });

  return lengthEst;
}

//when click on slected feild for estimate unit
// document
//   .querySelector('select[name="unitsEst"]')
//   .addEventListener("change", (event) => {
//     unitEst();
//     estimateDistanceUnitUpdate();
//     tableUnit();
//     milesToKmChartUnits();
//   });

function convertWholeChartToDifferentUnit() {
  if (window.measurement == unitKm) {
    measurement = unitMile;

    showmeasurement = unitMile;
    // document.querySelector('select[name="unitsDone"]').selectedIndex = 1;
  } else {
    measurement = unitKm;
    showmeasurement = unitKm;
    // document.querySelector('select[name="unitsDone"]').selectedIndex = 0;
  }
  // estimateDistanceUnitUpdate();

  setCookie(paceCookie, measurement);
  tableUnit();
  milesToKmChartUnits();
  estTime();
}



